// JPEG image export. Temporarily re-transforms the live stage to fit the
// union bbox at scale=1, snapshots, restores. Output is a Blob downloaded
// via triggerDownload. 2× pixelRatio gives retina-crisp text; quality 0.92
// is visually-lossless for whiteboard content.

import type Konva from 'konva';
import type { Shape } from '@frame/shared';
import { canvasToBlob, snapshotStageRegion } from './snapshot';
import { exportFilename, triggerDownload } from './download';

export interface ImageExportOpts {
  pixelRatio?: number;
  quality?: number;
  background?: string;
}

export async function exportJpeg(
  stage: Konva.Stage,
  shapes: readonly Shape[],
  boardId: string,
  opts: ImageExportOpts = {},
): Promise<void> {
  const canvas = await snapshotStageRegion(stage, shapes, {
    pixelRatio: opts.pixelRatio ?? 2,
    background: opts.background ?? '#ffffff',
  });
  const blob = await canvasToBlob(canvas, 'image/jpeg', opts.quality ?? 0.92);
  triggerDownload(blob, exportFilename(boardId, 'jpg'));
}
